(function () {
  function publishCalculatorCompleted() {
    console.log("RC: Results clicked — publishing Shopify analytics event…");

    // Shopify analytics event bus (works on storefront)
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
      Shopify.analytics.publish("aiq_calculator_completed", {
        source: "room_calculator",
        action: "results_tab_clicked",
        timestamp: Date.now()
      });
      console.log("RC: Published event aiq_calculator_completed");
    } else {
      console.warn("RC: Shopify.analytics.publish not available.");
    }
  }

  document.addEventListener("click", function (e) {
    const btn = e.target && e.target.closest && e.target.closest("button.rc-step");
    if (!btn) return;

    const label = (btn.textContent || "").trim();
    if (label === "Results") publishCalculatorCompleted();
  });
})();
